import {MuiPickersUtilsProvider} from "@material-ui/pickers";
import React, {Suspense, useLayoutEffect, useRef, useState} from "react";
import {fbConfig} from "../utils/fbConfig";
import {CssBaseline, MuiThemeProvider} from "@material-ui/core";
import MomentUtils from "@date-io/moment";
import {NotificationProvider} from "./NotificationContext";
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import {initSystem} from "../provider/system.service";
import {getToken, removeToken, setToken} from "../utils/storage";
import {GoogleLogin} from "react-google-login";
import setThemeReducer from '../assets/theme';
import {getBrowserFamily} from '../utils/browser';
import {FirebaseAppProvider} from 'reactfire';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';

firebase.initializeApp(fbConfig);
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL).then();
firebase.firestore().settings({
    cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
});
firebase.firestore().enablePersistence({synchronizeTabs: true}).then();

export function GlobalProviders(props) {
    const [customTheme, setCustomTheme] = useState();
    const [displayTheme, setDisplayTheme] = useState(setThemeReducer());
    const reference = useRef();

    useLayoutEffect(() => {
        if (customTheme){
            setDisplayTheme(setThemeReducer(customTheme))
        }
    }, [customTheme])

    // console.log(displayTheme)
    // window.prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    return <FirebaseAppProvider firebaseApp={firebase} firebaseConfig={fbConfig}>
        <Suspense fallback={<Grid item md={4} sm={12} lg={3}>
            <CircularProgress color="secondary"/>
        </Grid>}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <MuiThemeProvider theme={{...displayTheme, setCustomTheme}}>
                    <CssBaseline/>
                    <NotificationProvider ref={reference}>
                        <>
                            {props.children}
                            {
                                <GoogleLogin
                                    scope={'profile email'}
                                    key={'login'}
                                    clientId={fbConfig.clientId}
                                    render={() => <></>}
                                    approvalPrompt="force"
                                    responseType="id_token"
                                    accessType="online"
                                    isSignedIn
                                    redirectUri={process.env.REDIRECT_URI}
                                    offline
                                    prompt="consent"
                                    uxMode={!getBrowserFamily('electron') ? 'popup' : 'redirect'}
                                    onSuccess={loginApp}
                                    onFailure={(...err) => console.log('err login', err)}
                                    fetchBasicProfile={true}
                                    cookiePolicy={'none'}
                                />
                            }
                        </>
                    </NotificationProvider>
                </MuiThemeProvider>
            </MuiPickersUtilsProvider>
        </Suspense>
    </FirebaseAppProvider>
}

export const logoutApp = window.logout = (history) => {
    removeToken();
    firebase.app().auth().signOut().finally(() => {
        firebase.app().firestore().clearPersistence().catch(() => {
        });
        history.push('/');
    }).catch(() => {
    });
};

const ALLOWED_DOMAINS = process.env.REACT_APP_ALLOWED_DOMAINS?.split(',').map(item => item.trim()) ?? [];

export const loginApp = (res) => {
    const email = res?.profileObj?.email ?? '';
    const domain = email.split('@')[1];

    if (!ALLOWED_DOMAINS.includes(domain)) {
        window.alert(`Acesso não autorizado`);
        return;
    }

    if (res?.idToken !== getToken().token) {
        setToken(res.tokenObj);
        const credential = firebase.auth.GoogleAuthProvider.credential(res.tokenId);
        firebase.auth().signInWithCredential(credential).then(initSystem).catch(console.log)
    }
};
